import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useSnackbar } from 'notistack';
import Box from '@material-ui/core/Box';
import DialogTitle from '@material-ui/core/DialogTitle';
import ChangeRouteForm from '../../../../components/ChangeRouteForm';
import Dialog from '@afosto/app-components-react/Dialog';
import { items as itemsApi } from '@afosto/order/api/Items';
import translations from './translations';

const RoutesDialog = ({ isOpen, items, onClose, onSave, order }) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  const collectRoutes = items.reduce(
    (acc, item) =>
      (item.collect_routes ?? []).reduce(
        (routeAcc, route) => ({ ...routeAcc, [route.id]: route }),
        acc,
      ),
    {},
  );
  const deliveryRoutes = items.reduce(
    (acc, item) =>
      (item.delivery_routes ?? []).reduce(
        (routeAcc, route) => ({ ...routeAcc, [route.id]: route }),
        acc,
      ),
    {},
  );
  const possibleDeliveryRoutes = Object.values(deliveryRoutes);
  const possibleCollectRoutes = Object.values(collectRoutes);

  const handleChangeRoutes = async ({ collectRoute, deliveryRoute }) => {
    try {
      const filteredItems = items.filter(item => {
        if (!deliveryRoute && !collectRoute) {
          return true;
        }

        if (!deliveryRoute && collectRoute) {
          return (item?.collect_routes ?? []).some(route => route.id === collectRoute.id);
        }

        return (item?.delivery_routes ?? []).some(route => route.id === deliveryRoute.id);
      });
      const ids = filteredItems.reduce((acc, item) => [...acc, ...(item?.ids ?? [])], []);

      await itemsApi.setRoute(order?.id, [
        {
          item_ids: ids,
          collect_route_id: collectRoute?.id ?? null,
          delivery_route_id: deliveryRoute?.id ?? null,
        },
      ]);

      if (onSave && typeof onSave === 'function') {
        onSave();
      }

      enqueueSnackbar(intl.formatMessage(translations.feedback.routeChanged), {
        variant: 'success',
      });
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.routeNotChanged), {
        variant: 'error',
      });
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth>
      <DialogTitle>{intl.formatMessage(translations.title)}</DialogTitle>
      <Box px={2} pb={2}>
        <ChangeRouteForm
          onCancel={onClose}
          onSubmit={handleChangeRoutes}
          showQuantity={false}
          orderItem={{
            collect_routes: possibleCollectRoutes,
            delivery_routes: possibleDeliveryRoutes,
          }}
        />
      </Box>
    </Dialog>
  );
};

RoutesDialog.propTypes = {
  isOpen: PropTypes.bool,
  items: PropTypes.array,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  order: PropTypes.object,
};

RoutesDialog.defaultProps = {
  isOpen: false,
  items: [],
  onClose: undefined,
  onSave: undefined,
  order: undefined,
};

export default RoutesDialog;
